import React from 'react';

const Footer = () => {
  return (
    <div className="container-fluid footer py-5 wow fadeIn" data-wow-delay="0.2s">
      <div className="container py-5">
        <div className="row g-5">
          {/* Newsletter */}
          <div className="col-md-6 col-lg-6 col-xl-3">
            <div className="footer-item d-flex flex-column">
              <h4 className="text-white mb-4">Newsletter</h4>
            <p className="mb-3">
  Emperia Icon, Nerul – a premium address in Navi Mumbai offering modern commercial and residential spaces with top-class amenities and excellent connectivity.
</p>


              <div className="position-relative mx-auto">
                <input
                  className="form-control w-100 py-3 ps-4 pe-5"
                  type="text"
                  placeholder="Enter your email"
                />
                <button
                  type="button"
                  className="btn btn-secondary position-absolute top-0 end-0 py-2 mt-2 me-2"
                >
                  SignUp
                </button>
              </div>
            </div>
          </div>

          {/* Explore Links */}
          <div className="col-md-6 col-lg-6 col-xl-3">
            <div className="footer-item d-flex flex-column">
              <h4 className="text-white mb-4">Explore</h4>
              {['Home', 'Price', 'Site & Floor Plan', 'Amenities', 'Gallery', 'Location', 'Contact Us'].map((item, index) => (
                <a href="#" key={index}>
                  <i className="fas fa-angle-right me-2"></i> {item}
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div className="col-md-6 col-lg-6 col-xl-3">
            <div className="footer-item d-flex flex-column">
              <h4 className="text-white mb-4">Our Services</h4>
              {[
                'General Construction',
                'Property Maintenance',
                'Project Managment',
                'Virtual Design & Build',
                'Residential Construction',
                'Preconstruction',
                'Design Build',
              ].map((service, index) => (
                <a href="#" key={index}>
                  <i className="fas fa-angle-right me-2"></i> {service}
                </a>
              ))}
            </div>
          </div>

          {/* Contact Info */}
          <div className="col-md-6 col-lg-6 col-xl-3">
            <div className="footer-item d-flex flex-column">
              <h4 className="text-white mb-4">Contact Info</h4>
              <a href="#"><i className="fa fa-map-marker-alt me-2"></i> Nerul, Navi Mumbai</a>
              <a href="#"><i className="fas fa-envelope me-2"></i> info@minespacerealty.com</a>
              <a href="#"><i className="fas fa-envelope me-2"></i> info@minespacerealty.com</a>
              <a href="#"><i className="fas fa-phone me-2"></i> +919920992557</a>
              <a href="#" className="mb-3"><i className="fas fa-print me-2"></i> +919920992557</a>
              <div className="footer-btn d-flex align-items-center">
                <a className="btn btn-secondary btn-md-square me-2" href="#"><i className="fab fa-facebook-f text-white"></i></a>
                <a className="btn btn-secondary btn-md-square me-2" href="#"><i className="fab fa-twitter text-white"></i></a>
                <a className="btn btn-secondary btn-md-square me-2" href="#"><i className="fab fa-instagram text-white"></i></a>
                <a className="btn btn-secondary btn-md-square me-0" href="#"><i className="fab fa-linkedin-in text-white"></i></a>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Footer;
